import React from "react";
import { FaStarOfLife, FaGithub } from "react-icons/fa";
import { MdAdsClick } from "react-icons/md";

import "./project.css";


const Project = () => {
  return (
    <div id="project">
    <div className='myexhead'>
    <h3 style={{marginBottom:5}} className=''>My Recent Works</h3>
    <h2 style={{marginBottom:0}} className='fnt40'>Project</h2>
       </div> 
      
   <div className="containers" >            
    <div className="myexps">  
     <div className='descs'>
   <div className="descsubs">               
                <img src="/trystas1.png" fetchpriority="high" className='imgbox' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu" />                
                <span style={{marginTop:5}}>Bootstrap | Javascript | HTML |CSS | Responsive User Interface Design</span>          
                    
               <a href="https://trystash.me/new/" target="_blank" rel="noopener noreferrer" aria-label="View Professional Portfolio Website in AngularJs">
                <MdAdsClick className="view" size={33} />
                </a>
                <a href="https://trystash.me/new/" className="vgit" target="_blank" rel="noopener noreferrer" aria-label="View Professional Portfolio Website in AngularJs">
                <FaGithub size={33} />
                </a>
            </div> 
 <div className="descsubs">               
                <img src="/trystas2.png" fetchpriority="high" className='imgbox' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu" />                
                <span style={{marginTop:5}}>Bootstrap | Javascript | HTML |CSS | Responsive User Interface Design</span>          
                    
               <a href="https://trystash.me/new/" target="_blank" rel="noopener noreferrer" aria-label="View Professional Portfolio Website in AngularJs">
                <MdAdsClick className="view" size={33} />
                </a>
                <a href="https://trystash.me/new/" className="vgit" target="_blank" rel="noopener noreferrer" aria-label="View Professional Portfolio Website in AngularJs">
                <FaGithub size={33} />
                </a>
            </div> 
{/*<div className="descsubs">               
                <img src="/recipetipsinangularjs-sivaraj47.github.io.jpg" fetchpriority="high" className='imgbox' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu" />                
                <span style={{marginTop:5}}>Recipe Tips in Angularjs Website|HTML5 | Css3 | Angularjs | API|</span>          
                    
               <a href="https://sivaraj47.github.io/Recipe Tips Angularjs/" target="_blank" rel="noopener noreferrer" aria-label="View Recipe Tips in Angularjs Website">
                <MdAdsClick className="view" size={33} />
                </a>
                <a href="https://sivaraj47.github.io/Recipe-Tips-in-Angularjs/" className="vgit" target="_blank" rel="noopener noreferrer" aria-label="View Recipe Tips in Angularjs Website">
                <FaGithub size={33} />
                </a>
            </div>  
  <div className="descsubs">               
                <img src="/Professional-Portfolio-Website-in-AngularJs.webp" fetchpriority="high" className='imgbox' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu" />                
                <span style={{marginTop:5}}>Professional Portfolio Website in AngularJs|HTML5 | Css3 | Angularjs | API|</span>          
                    
               <a href="https://sivaraj47.github.io/Professional-Portfolio-Website-in-AngularJs/" target="_blank" rel="noopener noreferrer" aria-label="View Professional Portfolio Website in AngularJs">
                <MdAdsClick className="view" size={33} />
                </a>
                <a href="https://sivaraj47.github.io/Professional-Portfolio-Website-in-AngularJs/" className="vgit" target="_blank" rel="noopener noreferrer" aria-label="View Professional Portfolio Website in AngularJs">
                <FaGithub size={33} />
                </a>
            </div> */}
{/* <div className="descsubs">               
                <img src="/portfolio-website-html-css-js-responsive.webp" fetchpriority="high" className='imgbox' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu" />                
                <span style={{marginTop:5}}>Modern Unique Portfolio Website Design |HTML5 | Css3 |</span>         
                    
               <a href="https://sivaraj47.github.io/Modern-Unique-Portfolio-Design/" target="_blank" rel="noopener noreferrer" aria-label="View Modern Unique Portfolio Website Design">
                <MdAdsClick className="view" size={33} />
                </a>
                <a href="https://sivaraj47.github.io/Modern-Unique-Portfolio-Design/" className="vgit" target="_blank" rel="noopener noreferrer" aria-label="View Modern Unique Portfolio Website Design">
                <FaGithub size={33} />
                </a>
            </div>  */}
{/* <div className="descsubs">              
                <img src="/food-order-website.webp" className='imgbox' fetchpriority="high" alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu" />                
                <span style={{marginTop:5}}>Food Order Website Design| HTML5 | Css3 |</span>           
                         
               <a href="https://sivaraj47.github.io/food-order-website-design/" target="_blank" rel="noopener noreferrer" aria-label="View Food Order Website Design">
                <MdAdsClick className="view" size={33} />
                </a>
            </div> 
            <div className="descsubs">               
                <img src="/Payout-UPI-ID-design.jpg" className='imgbox' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu" />                
                <span style={{marginTop:5}}>Payout UPI ID Design | Figma </span>          
                    
               <a href="https://www.figma.com/proto/UVWgmKRUuDVDAv5j703fje/Payout-UPI-ID?node-id=5-76&starting-point-node-id=1%3A51&t=DS8QJSq6KcrCKZJ1-1" target="_blank" rel="noopener noreferrer" aria-label="View Payout UPI ID design on Figma">
                <MdAdsClick className="view" size={33} />
                </a>
                <a href="https://www.figma.com/proto/UVWgmKRUuDVDAv5j703fje/Payout-UPI-ID?node-id=5-76&starting-point-node-id=1%3A51&t=DS8QJSq6KcrCKZJ1-1" classname="vgit" target="_blank" rel="noopener noreferrer" aria-label="View Payout UPI ID design on Figma">
                <FaGithub size={33} />
                </a>
            </div>  
           <div className="descsubs">               
                <img src="/travel-info-card-design.jpg" className='imgbox' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu" />                
                <span style={{marginTop:5}}> Travel Info Card Design | HTML5 | Css3 | </span>          
                    
               <a href="https://sivaraj47.github.io/Travel-Info-Card-Design/" target="_blank" rel="noopener noreferrer" aria-label="View Travel Info Card Design">
                <MdAdsClick className="view" size={33} />
                </a>
                <a href="https://sivaraj47.github.io/Travel-Info-Card-Design/" className="vgit" target="_blank" rel="noopener noreferrer" aria-label="View Travel Info Card Design">
                <FaGithub size={33} />
                </a>
            </div>  
             <div className="descsubs">               
                <img src="/Professional-Card-Info-Design-sivaraj47-github-io.jpg" className='imgbox' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu"/>                
                <span style={{marginTop:5}}>Professional-info-card-design-html-css | HTML5 | Css3 | </span>          
                    
               <a href="https://sivaraj47.github.io/professional-info-card-design-html-css/" target="_blank" rel="noopener noreferrer" aria-label="View Professional Info Card Design html css">
                <MdAdsClick className="view" size={33} />
                </a>
                <a href="https://sivaraj47.github.io/professional-info-card-design-html-css/" className="vgit" target="_blank" rel="noopener noreferrer" aria-label="View Professional Info Card Design html css">
                <FaGithub size={33} />
                </a>
            </div>  
  <div className="descsubs">               
                <img src="/my-bio.webp" className='imgbox' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu" />                
                <span style={{marginTop:5}}>My GitHub Bio in AngularJs|HTML5 | Css3 | Angularjs | API|</span>          
                    
               <a href="https://sivaraj47.github.io/my-bio/" target="_blank" rel="noopener noreferrer" aria-label="View My GitHub Bio in AngularJs">
                <MdAdsClick className="view" size={33} />
                </a>
                <a href="https://sivaraj47.github.io/my-bio/" className="vgit" target="_blank" rel="noopener noreferrer" aria-label="View My GitHub Bio in AngularJs">
                <FaGithub size={33} />
                </a>
            </div>  
 
            <div className="descsubs">              
                <img src="/banner-design.png" className='imgbox' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu"/>                
                <span style={{marginTop:5}}>Professional Banner Website in html css |HTML 5 | Css3 |</span>           
                         
               <a href="https://sivaraj47.github.io/Professional-Banner-Design-in-html-CSS/" target="_blank" rel="noopener noreferrer" aria-label="Professional Banner Website in html css">
                <MdAdsClick className="view" size={33} />
                </a>
            </div> 
            <div className="descsubs">              
                <img src="/sidebar-website.png" className='imgbox' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu" />                
                <span style={{marginTop:5}}>Sidebar Menu Collapse and Expand|HTML | Css| Js</span>           
                         
               <a href="https://sivaraj47.github.io/Sidebar-Menu-Collapse-and-Expand/" target="_blank" rel="noopener noreferrer" aria-label="Sidebar Menu Collapse and Expand Html css">
                <MdAdsClick className="view" size={33} />
                </a>
            </div> 
  
            <div className="descsubs">              
                <img src="/login-signup.png" className='imgbox' alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu" />                
                <span style={{marginTop:5}}>Login Sign Up Form using Javascript |Html|Css| Js</span>           
                         
               <a href="https://sivaraj47.github.io/Login-Sign-Up-Form-using-Javascript/" target="_blank" rel="noopener noreferrer" aria-label="Login Sign Up Form using Javascript">
                <MdAdsClick className="view" size={33} />
                </a>
            </div> */}
  

                
      </div>      
    <div className="cbtn"><a href="/frontend-developer-builds-custom-website" className="btn-primary" alt="professional web design and development chennai trichy tamilnadu" title="frontend developer uiux designer chennai trichy tamilnadu">Development Videos</a></div>
   </div>
    </div>  
    <div className='role' style={{display:'none'}}>
    <div className='roleinfo'>
    <span>Dashboard</span><span><FaStarOfLife/></span>
    <span>Admin Design</span><span><FaStarOfLife/></span>
    <span>Landing Website</span><span><FaStarOfLife/></span>
    <span>Dynamic Website</span><span><FaStarOfLife/></span>
    <span>Mobile App Design</span><span><FaStarOfLife/></span>
    </div>
    </div>
    </div>
  );
};

export default Project;






















